const LoadState = {
  NotExist: 1,
  MissingContent: 2,
  MissingStyle: 3,
  Loaded: 4,
};

export default Object.freeze(LoadState);
